// extracted by mini-css-extract-plugin
export default {"remove":"CardTitle_remove__iv-UN","clickArea":"CardTitle_clickArea__jSSPB"};